module.exports = __webpack_public_path__ + "static/user-thumbnail-2-06449a124037513cb802ec950217225b.jpg";